
export const createError = (
    hasError,
    errorCode=null,
    message=null,
) => ({
  hasError,
  errorCode,
  message,
});